import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRoute from "./PrivateRoute";
import China from "./pages/China/China";
import CustomerService from "./pages/CustomerService/CustomerService";
import Admin from "./pages/Admin/Admin";
import Register from "./pages/Admin/Register";
import Shipment from "./pages/Shipment";
import Summary from "./pages/Summary/Summary";
import Setting from "./pages/Setting";
import Finance from "./pages/Admin/Finance";
import Delivery from "./pages/Delivery";
import DeliveryAdmin from "./pages/Admin/DeliveryAdmin";
import Attendance from "./pages/Attendance";
import CustomSummary from "./pages/CustomerService/CustomSummary";
import ChangePass from "./pages/ChangePass";
import CustomerServiceAttendance from "./pages/CustomerService/CustomerServiceAttendance";
import FromWhere from "./pages/FromWhere";
import ShippedTo from "./pages/Summary/component/ShippedTo";
import EthioProducts from "./pages/Ethio/EthioProducts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Posting from "./component/Posting";
import Adama from "./pages/Adama/Adama";
import HistoryPage from "./pages/Admin/HistoryPage";
import CnSummary from "./pages/China/CnSummary";
import Editor from "./pages/Editor";
import CustomerFollowUp from "./pages/CustomerService/CustomerFollowUp";
import FinanceSummary from "./pages/Admin/component/FinanceSummary";
import ESummary from "./pages/CustomerService/components/ESummary";
import Expenses from "./pages/Admin/component/Expenses";
import PrepareOrder from "./pages/China/PrepareOrder";
import ScannerPage from "./pages/Scanner/ScannerPage";
import StockCheckPage from "./pages/Scanner/StockCheckPage";
import StockCheckHistoryPage from "./pages/Scanner/StockCheckHistoryPage";
import Print from "./pages/China/Print";
import BankTransactions from "./pages/Banking/BankTransactions";

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/register"
            element={<PrivateRoute element={<Register />} />}
          />
          <Route path="/" element={<PrivateRoute element={<Home />} />} />
          <Route
            path="/china"
            element={
              <PrivateRoute element={<China />} roles={["China", "Admin"]} />
            }
          />
          <Route
            path="/ShippedTo"
            element={
              <PrivateRoute
                element={<ShippedTo />}
                roles={["China", "Admin"]}
              />
            }
          />
          <Route
            path="/customerService"
            element={
              <PrivateRoute
                element={<CustomerService />}
                roles={["CustomerService", "Admin"]}
              />
            }
          />
          <Route
            path="/CustomSummary"
            element={
              <PrivateRoute
                element={<CustomSummary />}
                roles={["CustomerService", "Admin", "Editor"]}
              />
            }
          />
          <Route
            path="/ESummary"
            element={
              <PrivateRoute
                element={<ESummary />}
                roles={["Admin", "Editor"]}
              />
            }
          />
          <Route
            path="/followUp"
            element={
              <PrivateRoute
                element={<CustomerFollowUp />}
                roles={["CustomerService", "Admin"]}
              />
            }
          />
          <Route
            path="/ChangePassword"
            element={
              <PrivateRoute
                element={<ChangePass />}
                roles={["CustomerService", "Admin", "Editor"]}
              />
            }
          />
          <Route
            path="/CSAttendance"
            element={
              <PrivateRoute
                element={<CustomerServiceAttendance />}
                roles={["CustomerService", "Admin", "Editor"]}
              />
            }
          />
          <Route
            path="/shipment"
            element={
              <PrivateRoute
                element={<Shipment />}
                roles={["Shipment", "Admin"]}
              />
            }
          />
          <Route
            path="/admin"
            element={<PrivateRoute element={<Admin />} roles={["Admin"]} />}
          />
          <Route
            path="/summary"
            element={
              <PrivateRoute element={<Summary />} roles={["User", "Admin"]} />
            }
          />
          <Route
            path="/setting"
            element={<PrivateRoute element={<Setting />} roles={["Admin"]} />}
          />
          <Route
            path="/finance"
            element={
              <PrivateRoute
                element={<Finance />}
                roles={["Finance", "Admin"]}
              />
            }
          />
          <Route
            path="/delivery"
            element={
              <PrivateRoute
                element={<Delivery />}
                roles={["Delivery", "Admin"]}
              />
            }
          />
          <Route
            path="/deliveryAdmin"
            element={
              <PrivateRoute
                element={<DeliveryAdmin />}
                roles={["DeliveryAdmin", "Admin"]}
              />
            }
          />
          <Route
            path="/attendance"
            element={
              <PrivateRoute element={<Attendance />} roles={["Admin"]} />
            }
          />
          <Route
            path="/fromWhere"
            element={
              <PrivateRoute
                element={<FromWhere />}
                roles={["Admin", "CustomerService"]}
              />
            }
          />
          <Route
            path="/EthioProducts"
            element={
              <PrivateRoute
                element={<EthioProducts />}
                roles={["Admin", "CustomerService"]}
              />
            }
          />
          <Route
            path="/Fin"
            element={
              <PrivateRoute
                element={<FinanceSummary />}
                roles={["Admin", "CustomerService"]}
              />
            }
          />
          <Route
            path="/Posting"
            element={
              <PrivateRoute
                element={<Posting />}
                roles={["Admin", "CustomerService"]}
              />
            }
          />
          <Route
            path="/Adama"
            element={
              <PrivateRoute
                element={<Adama />}
                roles={["Admin", "Adama"]}
              />
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute
                element={<HistoryPage />}
                roles={["Admin"]}
              />
            }
          />
          <Route
            path="/CnSummary"
            element={
              <PrivateRoute
                element={<CnSummary />}
                roles={["Admin", "China"]}
              />
            }
          />
          <Route
            path="/Editing"
            element={
              <PrivateRoute
                element={<Editor />}
                roles={["Admin", "Editor"]}
              />
            }
          />
          <Route
            path="/Expenses"
            element={
              <PrivateRoute
                element={<Expenses />}
                roles={["Admin"]}
              />
            }
          />
          <Route
            path="/PrepareOrder"
            element={
              <PrivateRoute
                element={<PrepareOrder />}
                roles={["Admin","China"]}
              />
            }
          />
          <Route
            path="/scanner"
            element={
              <PrivateRoute
                element={<ScannerPage />}
                roles={["Admin", "China", "CustomerService", "Editor"]}
              />
            }
          />
            <Route
              path="/stockCheck"
              element={
                <PrivateRoute
                  element={<StockCheckPage />}
                  roles={["Admin"]}
                />
              }
            />
            <Route
              path="/stock-check-history"
              element={
                <PrivateRoute
                  element={<StockCheckHistoryPage />}
                  roles={["Admin"]}
                />
              }
            />
          <Route
            path="/print"
            element={
              <PrivateRoute
                element={<Print />}
                roles={["Admin","China"]}
              />
            }
          />
          <Route
            path="/banking"
            element={
              <PrivateRoute
                element={<BankTransactions />}
                roles={["Admin"]}
              />
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
